import "./Loader.scss"; // Import the CSS file
export default function LoaderTyping(){
    return<div className="typing-loader">
    <span></span>
    <span></span>
    <span></span>
  </div>
}